<template>
  <auth-layout>
    <template v-if="!sent">
      <h1 class="pop-auth__h1">Reset your password</h1>
      <p class="pop-auth__sub">Enter the email on your account and we will send a reset link.</p>
      <form novalidate @submit.prevent="submit">
        <label class="pop-auth__label" for="forgot-email">Email</label>
        <input
          id="forgot-email"
          v-model.trim="email"
          class="pop-auth__field"
          :class="{ 'is-invalid': Boolean(error) }"
          type="email"
          placeholder="you@company.com"
          autocomplete="email"
          data-test="forgot-email"
          @input="error = ''"
        />
        <div v-if="error" class="pop-auth__err">{{ error }}</div>
        <turnstile-widget ref="captcha" action="forgot_password" @token="captchaToken = $event" @expired="captchaToken = ''" />
        <button type="submit" class="pop-auth__btn pop-auth__btn--primary" :disabled="busy || captchaPending" data-test="forgot-submit">
          {{ busy ? 'Sending' : 'Send reset link' }}
        </button>
      </form>
      <p class="pop-auth__fine pop-auth__center" style="margin-top: 20px">
        <router-link class="pop-auth__link" to="/login">Back to log in</router-link>
      </p>
    </template>
    <template v-else>
      <h1 class="pop-auth__h1">Check your inbox</h1>
      <p class="pop-auth__sub">If an account exists for that address, a reset link is on its way. It expires in 30 minutes.</p>
      <div class="pop-auth__box pop-auth__box--muted" style="margin-top: 0">
        Signed up with Google or Apple? There is no password to reset.
        <router-link class="pop-auth__link" to="/login">Log in with Google or Apple</router-link> instead.
      </div>
      <p class="pop-auth__fine" style="margin-top: 20px">
        <router-link class="pop-auth__link" to="/login">Back to log in</router-link>
      </p>
    </template>
  </auth-layout>
</template>

<script>
import AuthLayout from '../AuthLayout.vue'
import TurnstileWidget from '../TurnstileWidget.vue'
import { isTurnstileEnabled } from '@/utils/turnstile'
import { segmentPage, segmentTrack } from '@/utils'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export default {
  name: 'ForgotPasswordPage',
  components: { AuthLayout, TurnstileWidget },
  data() {
    return { email: String(this.$route.query.email || ''), sent: false, busy: false, error: '', captchaToken: '' }
  },
  computed: {
    captchaPending() {
      return isTurnstileEnabled() && !this.captchaToken
    },
  },
  mounted() {
    segmentPage('ForgotPassword', {})
  },
  methods: {
    async submit() {
      if (!EMAIL_RE.test(this.email)) {
        this.error = 'Enter a valid email address.'
        return
      }
      this.busy = true
      try {
        const captchaToken = this.captchaToken
        const response = await this.$store.dispatch('requestPasswordReset', { email: this.email, captchaToken })
        const data = response.data || {}
        if (data.action === 'CAPTCHA_FAILED') {
          this.error = data.msg
          return
        }
        segmentTrack('password_reset_requested', { email: this.email })
        this.sent = true
      } catch (e) {
        console.log(e)
        this.sent = true // never reveal whether the address exists
      } finally {
        this.busy = false
        if (this.$refs.captcha) this.$refs.captcha.reset() // tokens are single-use
      }
    },
  },
}
</script>
